import React, { memo } from 'react';

/**
 * A horizontal line that conencts each step of the StepIndicator
 *
 * @param {boolean} isCompleted - indicates if the line should be
 * @param {string} className - adds custom classname to the connector line
 * @returns {JSX.Element|null}
 */
const ConnectorLine = memo(({ isCompleted, className }) => {
  const connectorBgClass = isCompleted ? 'bg-custom-blue-deep' : 'bg-custom-gray-muted';
  const connectorClasses = `
      absolute h-0.5 w-full top-[22px] -left-[50%]
      transition-colors duration-300
      ${connectorBgClass}
      ${className}
    `;

  return <div aria-hidden="true" className={connectorClasses} />;
});

export default ConnectorLine;
